import * as React from "react";
const IconProtectionCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M54.1 7.9 33 2.1c-.7-.1-1.3-.1-2 0L9.9 7.9c-1.6.4-2.7 1.9-2.7 3.5v15.4c0 15.5 9.2 29.2 23.4 34.9.4.2.9.3 1.4.3s.9-.1 1.4-.3c14.2-5.7 23.4-19.5 23.4-35V11.4c-.1-1.6-1.2-3.1-2.7-3.5m.6 18.8c0 14.5-8.9 27.8-22.1 33.1-.4.2-.9.2-1.3 0-13.4-5.4-22-18.3-22-33V11.4c0-.7.5-1.4 1.2-1.6L31.6 4h.4c.1 0 .3 0 .4.1l21.1 5.8c.7.2 1.2.9 1.2 1.6z" />
    <path d="M44.5 23.3 29.4 36l-7.3-6.1c-.4-.4-1.1-.3-1.4.1-.4.4-.3 1.1.1 1.4l7.9 6.6c.2.2.4.2.6.2s.5-.1.6-.2l15.8-13.3c.4-.4.5-1 .1-1.4-.2-.3-.8-.4-1.3 0" />
  </svg>
);
export default IconProtectionCopy;
